import { serialize } from '@/@core/libs/serialize/util'
import Http from './http'

export const broadcastList = params => Http.get(`/admin/broadcasts${serialize(params)}`)
export const broadcastById = id => Http.get(`/admin/broadcasts/${id}`)
export const createBroadcast = data => Http.post('/admin/broadcasts', data)
